import FacebookTable from './FacebookTable.Container';

export default FacebookTable;
